import { useI18n } from '@tm/client-app/src/i18n'
import { Toast } from '@tm/ui/atomic/Toast/Toast'
import { useState } from 'react'
import { useAppVersion } from './useAppVersion'

/**
 * Offers a reload to tabs left open across a deploy. Deliberately not a
 * forced reload: the tab may hold an unsent form.
 *
 * It does not time out, unlike the outcome toasts this shares its shell with —
 * a prompt that vanished while the user looked away would never come back,
 * since dismissing is permanent for the tab.
 */
export function UpdatePrompt() {
  const { t } = useI18n()
  const { updateAvailable, reload } = useAppVersion()
  const [dismissed, setDismissed] = useState(false)

  return (
    <Toast
      open={updateAvailable && !dismissed}
      message={t('app.updateAvailable.text')}
      action={{ label: t('app.updateAvailable.action'), onClick: reload }}
      onClose={() => setDismissed(true)}
      autoHideDuration={null}
      dismissLabel={t('common.close')}
    />
  )
}
